import styled from 'styled-components'

export const Container = styled.div`
    width: 100%;
    height: 100%;
    background: #36383c;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0px 16px 0px 8px;

    .hover-here {
        opacity: 0.5;
        cursor: pointer;
        & > * {
            cursor: pointer;
        }

        :hover {
            opacity: 1;
            background-color: #ffffff24;
        }
    }
`
